import * as Sentry from '@sentry/react';
import env from '~/env';

export function addBreadcrumb(breadcrumb: Sentry.Breadcrumb) {
  if (env.VITE_NODE_ENV === 'dev') {
    // oxlint-disable-next-line no-console -- only applies in dev
    console.info('Breadcrumb', breadcrumb);
  }
  Sentry.addBreadcrumb(breadcrumb);
}

export function identifyUser({
  email,
  storeId,
  storeName,
}: {
  email: string;
  storeName?: string;
  storeId?: number;
}) {
  if (env.VITE_NODE_ENV === 'dev') {
    // oxlint-disable-next-line no-console -- only applies in dev
    console.info('Identify User', { email, storeId, storeName });
  }
  Sentry.setUser({
    email,
    username: email,
  });
  if (storeName) Sentry.setTag('storeName', storeName);
  if (storeId) {
    Sentry.setTag('storeId', storeId.toString());
  }
}

/** Force-starts session replay recording, bypassing the sample rate. No-ops if Sentry isn't initialized (e.g. dev). */
export function startDebugReplay() {
  // force start a replay, where `start()` would no-op if in buffer mode, this will ensure switching to session
  Sentry.getReplay()
    ?.flush()
    .catch((error) => {
      console.error('Failed to start debug replay:', error);
    });
}

/** Stops replay recording without sending it. */
export async function stopDebugReplay() {
  await Sentry.getReplay()?.stop();
}

/** Flushes the active replay to Sentry, tags a linked issue, then stops recording. */
export async function sendAndStopDebugReplay({
  message,
  storeName,
}: {
  storeName: string;
  message?: string;
}) {
  const replay = Sentry.getReplay();
  if (!replay) throw new Error('Session replay is unavailable');

  await replay.flush();
  Sentry.captureException(
    new Error(`Merchant-UI bug report for ${storeName}`),
    {
      extra: { message },
      tags: { debugReplay: true, replayId: replay.getReplayId() },
    },
  );
  await replay.stop();
}
